import { Injectable } from '@angular/core';
import { PageRequest, Quotes, ServerDataResponse } from '@models/models';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import {
	QtIntroductionPayload,
	QtItemPayload,
	QTSaveDataPayload,
	QtTemplateListItem,
	QtTemplatePayload,
	QtTemplateType
} from '@models/qt-templates.model';
import { of } from 'rxjs/observable/of';
import { timeout } from 'rxjs/operators';

@Injectable()
export class QuoteInvoiceTemplatesDataService {
	constructor(private http: HttpClient) {}

	/*
		Could not be found by reference, because is being called with dynamic name.
		Used in qt-templates.component.ts | quote-update.ts | edit-quote.ts
	*/
	getQuoteTemplatesList(
		pageOptions: PageRequest
	): Observable<ServerDataResponse<QtTemplatePayload>> {
		const url = '/api/user/quote-sample/fixed/preview';
		return this.http.post(url, pageOptions) as Observable<
			ServerDataResponse<QtTemplatePayload>
		>;
	}

	/*
		Could not be found by reference, because is being called with dynamic name.
		Used in qt-templates.component.ts | quote-update.ts | edit-quote.ts
	*/
	getCustomQuoteTemplatesList(
		pageOptions: PageRequest
	): Observable<ServerDataResponse<QtTemplatePayload>> {
		const url = '/api/user/quote-sample/preview';
		return this.http.post(url, pageOptions) as Observable<
			ServerDataResponse<QtTemplatePayload>
		>;
	}

	/*
    	Could not be found by reference, because is being called with dynamic name.
    	Used in qt-templates.component.ts | invoice-update.ts
	*/
	getInvoiceTemplatesList(
		pageOptions: PageRequest
	): Observable<ServerDataResponse<QtTemplatePayload>> {
		const url = '/api/user/invoice-sample/preview';
		return this.http.post(url, pageOptions) as Observable<
			ServerDataResponse<QtTemplatePayload>
		>;
	}

	getQuoteIntroduction(): Observable<
		ServerDataResponse<QtIntroductionPayload>
	> {
		const url = '/api/user/quote-sample/introduction';
		return this.http.get(url) as Observable<
			ServerDataResponse<QtIntroductionPayload>
		>;
	}

	invokeDynamicRequest(
		url: string,
		method: string,
		data?: Object
	): Observable<Object> {
		if (data) {
			return this.http[method.toLowerCase()](url, data);
		}
		return this.http[method.toLowerCase()](url);
	}

	loadQtTemplate(
		id: string,
		type: QtTemplateType
	): Observable<ServerDataResponse<QtItemPayload>> {
		const url = `/api/user/${type.toLowerCase()}-sample/${id}`;
		return this.http.get(url) as Observable<ServerDataResponse<QtItemPayload>>;
	}

	saveTemplate(
		type: QtTemplateType,
		data: QTSaveDataPayload
	): Observable<ServerDataResponse<QtItemPayload>> {
		let url;
		if (type === 'CUSTOM_QUOTE') {
			url = '/api/user/quote-sample';
		}
		if (type === 'QUOTE') {
			url = '/api/user/quote-sample/fixed';
		}

		if (type === 'INVOICE') {
			url = '/api/user/invoice-sample';
		}
		return this.http.post(url, data) as Observable<
			ServerDataResponse<QtItemPayload>
		>;
	}

	editTemplate(
		type: QtTemplateType,
		id: string,
		data: QTSaveDataPayload
	): Observable<ServerDataResponse<QtItemPayload>> {
		let url;
		if (type === 'CUSTOM_QUOTE') {
			url = `/api/user/quote-sample/${id}`;
		}
		if (type === 'QUOTE') {
			url = `/api/user/quote-sample/fixed/${id}`;
		}

		if (type === 'INVOICE') {
			url = `/api/user/invoice-sample/${id}`;
		}

		return this.http.put(url, data) as Observable<
			ServerDataResponse<QtItemPayload>
		>;
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./shared/services/quote-invoice-templates/quote-invoice-templates.data.service.ts